import { RequestType } from './constants';

const BASE_URL = process.env.REACT_APP_BACKEND;

export async function fetchClient(
  path,
  { type = RequestType.POST, headers, body, baseUrl = BASE_URL } = {},
) {
  const response = await fetch(`${baseUrl}${path}`, {
    method: type,
    headers: {
      'Content-Type': 'application/json',
      ...(headers || {}),
    },
    body: body ? JSON.stringify(body) : undefined,
  });

  if (!response.ok) {
    let message = 'Network error';
    try {
      const errData = await response.json();
      message = errData?.message || JSON.stringify(errData);
    } catch {
      message = response.statusText || 'Unknown error';
    }
    const error = new Error(message);
    error.status = response.status;
    throw error;
  }

  return response.json();
}
